import React from 'react';



type Props = {
	children: React.ReactNode,
};



const PageTimestamp: React.FC<Props> = (props) => {
	const {
		children,
	} = props;

	return (
		<div className="page-timestamp">
			{children}
		</div>
	);
};



export default PageTimestamp;
